/**
 * Shared configuration for user warnings React Query hooks
 */

/**
 * One week in milliseconds
 * Used for caching user warnings data since it rarely changes
 */
export const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Default React Query options for user warnings endpoints
 * Provides caching since user warnings data rarely changes
 */
export const USER_WARNINGS_QUERY_CONFIG = {
  staleTime: ONE_WEEK_MS,
  gcTime: ONE_WEEK_MS,
} as const;
